import Siema from '../../../js/vendor/siema';
import { Helper } from '../../../js/util/helper';
import lozad from 'lozad';

export default class Cards {
  constructor( node ) {
    this.node = node;
    this.slider = null;
    this.sizeL = 1024;
    this.sizeXL = 1280;
    this.sizeXXL = 1920;
    //this.removeBackground();
    this.handleSlider();
    this.handleButtonPosition();
    this.initAccordionEventHandler();
    this.initDetailClickEvent();
    this.addEventhandler();

    const observer = lozad( this.node.querySelectorAll( '.lozad-cards' ), {
      rootMargin: '500px 0px',
      threshold: 0,
      load: function( picture ) {
        if ( picture.src === 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7' ) {
          let wrapper = Helper.getClosest( picture, '.cards' );
          let images = wrapper.querySelectorAll( 'img' );
          images.forEach(( image ) => {
            image.src = image.getAttribute( 'data-src' );
          });
        }
      }
    });
    observer.observe();
  }
  handleSlider() {
    let containerLength = this.node.querySelectorAll( '.cards__card-container' ).length;
    let amount = 1;
    if ( window.innerWidth > this.sizeXXL - 1 && containerLength > 4 ) {
      amount = 4;
      this.sliderFunction( amount );
    } else if ( window.innerWidth > this.sizeXL - 1 && window.innerWidth < this.sizeXXL && containerLength > 3 ) {
      amount = 3;
      this.sliderFunction( amount );
    } else if ( window.innerWidth >= this.sizeL - 1 && window.innerWidth < this.sizeXL && containerLength > 2 ) {
      amount = 2;
      this.sliderFunction( amount );
    } else if ( window.innerWidth < this.sizeL ) {
      this.sliderFunction( amount );
    }
    this.addButton();
    this.node.classList.add( 'cards--ready' );
  }
  handleButtonPosition() {
    let wrapper = Helper.getClosest( this.node, '.cards-outer' );
    let headlineHeight = wrapper.querySelector( '.headline' ).offsetHeight;
    let containerStyle = window.getComputedStyle( wrapper ) || wrapper.currentStyle;
    let imageContainerHeight = wrapper.querySelector( '.cards__image-container' ).offsetHeight;
    let buttons = wrapper.querySelectorAll( '.cards__button-container' );

    if ( wrapper.classList.contains( 'cards-outer--detail-view' ) && window.innerWidth < this.sizeXL ) {
      for ( let button of buttons ) {
        button.style.top = 270 + 'px';
      }
    } else if ( wrapper.classList.contains( 'cards-outer--detail-view' ) && window.innerWidth >= this.sizeXL ) {
      for ( let button of buttons ) {
        button.style.top = 320 + 'px';
      }
    } else {
      for ( let button of buttons ) {
        let containerPadding = parseInt( containerStyle.paddingTop.replace( 'px', '' ));
        let top = containerPadding + headlineHeight + imageContainerHeight * 0.55;
        button.style.top = top + 'px';
      }
    }
  }
  sliderFunction( amount ) {
    this.slider = this.initSlider( amount );
    this.node.children[ 0 ].classList.add( 'cards__slider' );
    this.isSlider = true;
    this.addPagination();
    this.setActivePagination( 0 );
    this.addAnimation();
  }
  addAnimation() {
    let containers = this.node.querySelectorAll( '.cards__card-container' );
    for ( let i = 0; i < containers.length; i++ ) {
      containers[ i ].classList.add( 'cards__card-container--hidden' );
      this.createAnimation( containers[ i ], i );
    }
  }
  createAnimation( container, i ) {
    setTimeout( function() {
      container.classList.remove( 'cards__card-container--hidden' );
    }, i * 150 );
  }
  initSlider( amount ) {
    let wrapper = Helper.getClosest( this.node, '.cards-outer' );
    if ( !wrapper.classList.contains( 'cards-outer--swipeable' )) {
      wrapper.classList.add( 'cards-outer--swipeable' );
    }
    return new Siema({
      selector: this.node,
      perPage: amount,
      loop: true,
      onChange: this.setActivePagination.bind( this )
    });
  }
  addPagination() {
    let wrapper = Helper.getClosest( this.node, '.cards-outer' );
    let paginationBtns = wrapper.querySelectorAll( '.cards__pagination-box' );
    for ( let paginationBtn of paginationBtns ) {
      paginationBtn.addEventListener( 'click', () => {
        const index = parseInt( paginationBtn.getAttribute( 'data-index' ));
        this.slider.goTo( index );
        this.setActivePagination( index );
      });
    }
  }
  setActivePagination( index = -1 ) {
    let wrapper = Helper.getClosest( this.node, '.cards-outer' ),
      paginationBtns = wrapper.querySelectorAll( '.cards__pagination-box' ),
      actives = wrapper.querySelectorAll( '.cards__pagination-box--active' ),
      slidesPerView = this.slider.perPage;
    let current = ( index === -1 ) ? this.slider.currentSlide : index;

    if ( current === -1 ) {
      current = paginationBtns.length - 1;
    } else if ( current === -2 ) {
      current = paginationBtns.length - 2;
    } else if ( current === -3 ) {
      current = paginationBtns.length - 3;
    }

    if ( actives !== null ) {
      actives.forEach( function( active ) {
        active.classList.remove( 'cards__pagination-box--active' );
      });
    }

    let restart = 0;
    for ( let i = 0; i < slidesPerView; i++ ) {
      if ( i === 0 ) {
        paginationBtns[ current ].classList.add( 'cards__pagination-box--active' );
      } else if ( current + i > paginationBtns.length - 1 ) {
        paginationBtns[ restart ].classList.add( 'cards__pagination-box--active' );
        restart = restart + 1;
      } else {
        paginationBtns[ current + i ].classList.add( 'cards__pagination-box--active' );
      }
    }

    this.handleNegativeMargin();
  }
  handleNegativeMargin() {
    let container = this.node.querySelectorAll( '.cards__card-container' );
    let currentContainer = this.node.querySelector( '.cards__card-container--current' );
    let current = this.slider.currentSlide;
    let viewport = 'L';

    // set current slide for CSS handling
    if ( currentContainer ) {
      currentContainer.classList.remove( 'cards__card-container--current' );
    }

    if ( current !== -2 ) {
      container[ current + 1 ].classList.add( 'cards__card-container--current' );
    } else {
      container[ container.length - 1 ].classList.add( 'cards__card-container--current' );
    }

    if ( window.innerWidth >= this.sizeL && window.innerWidth < this.sizeXL ) {
      viewport = 'L';
      current = this.slider.currentSlide + 2;
    } else if ( window.innerWidth >= this.sizeXL && window.innerWidth < this.sizeXXL ) {
      viewport = 'XL';
      current = this.slider.currentSlide + 3;
    } else if ( window.innerWidth >= this.sizeXXL ) {
      viewport = 'XXL';
      current = this.slider.currentSlide + 4;
    } else {
      viewport = 'Mobile';
    }

    for ( let i = 0; i < container.length; i++ ) {
      container[ i ].style.marginRight = 0;
      container[ i ].style.marginLeft = 0;

      if ( viewport === 'L' ) {
        let style = container[ i ].currentStyle || window.getComputedStyle( container[ i ]);
        if ( i === current && style.marginTop === '0px' ) {
          container[ i ].style.marginRight = -6 + 'rem';
        } else if ( i === current && style.marginTop === '50px' ) {
          container[ i ].style.marginRight = -4 + 'rem';
        } else if ( i === current + 1 ) {
          if ( style.marginTop === '0px' ) {
            container[ i ].style.marginLeft = -4 + 'rem';
          } else {
            container[ i ].style.marginLeft = -6 + 'rem';
          }
        }
      } else if ( viewport === 'XL' ) {
        let style = container[ i ].currentStyle || window.getComputedStyle( container[ i ]);
        if ( i === current && style.marginTop === '50px' ) {
          container[ i ].style.marginRight = -7 + 'rem';
        } else if ( i === current && style.marginTop === '0px' ) {
          container[ i ].style.marginRight = -6 + 'rem';
        } else if ( i === current + 1 && style.marginTop === '0px' ) {
          container[ i ].style.marginRight = -2 + 'rem';
        } else if ( i === current + 1 && style.marginTop === '50px' ) {
          container[ i ].style.marginRight = 2 + 'rem';
        } else if ( i === current + 2 && style.marginTop === '50px' ) {
          container[ i ].style.marginLeft = -7 + 'rem';
        } else if ( i === current + 2 && style.marginTop === '0px' ) {
          container[ i ].style.marginLeft = -6 + 'rem';
        }
      } else if ( viewport === 'XXL' ) {
        let style = container[ i ].currentStyle || window.getComputedStyle( container[ i ]);
        if ( i === current && style.marginTop === '50px' ) {
          container[ i ].style.marginRight = -17 + 'rem';
        } else if ( i === current && style.marginTop === '0px' ) {
          container[ i ].style.marginRight = -19 + 'rem';
        } else if ( i === current + 1 && style.marginTop === '0px' ) {
          container[ i ].style.marginRight = -7 + 'rem';
        } else if ( i === current + 1 && style.marginTop === '50px' ) {
          container[ i ].style.marginRight = -5 + 'rem';
        } else if ( i === current + 2 && style.marginTop === '50px' ) {
          container[ i ].style.marginLeft = -7 + 'rem';
        } else if ( i === current + 2 && style.marginTop === '0px' ) {
          container[ i ].style.marginLeft = -5 + 'rem';
        } else if ( i === current + 3 && style.marginTop === '50px' ) {
          container[ i ].style.marginLeft = -19 + 'rem';
        } else if ( i === current + 3 && style.marginTop === '0px' ) {
          container[ i ].style.marginLeft = -17 + 'rem';
        }
      }
    }
  }
  addButton() {
    let wrapper = Helper.getClosest( this.node, '.cards-outer' );

    wrapper.children[ 0 ].addEventListener( 'click', () => {
      this.slider.prev();
    });

    wrapper.children[ 1 ].addEventListener( 'click', () => {
      this.slider.next();
    });
  }
  initAccordionEventHandler() {
    let accordionContainers = this.node.querySelectorAll( '.cards__content-container-inner' );

    accordionContainers.forEach( function( accordionContainer ) {
      let accordionButton = accordionContainer.querySelector( '.cards__icon' );

      accordionButton.addEventListener( 'click', () => {
        accordionContainer.classList.toggle( 'cards__content-container-inner--open' );
        if ( accordionContainer.classList.contains( 'cards__content-container-inner--open' )) {
          accordionButton.classList.remove( 'collapsed' );
        } else {
          accordionButton.classList.add( 'collapsed' );
        }
      });
    });
  }
  initDetailClickEvent() {
    let wrapper = Helper.getClosest( this.node, '.cards-outer' );

    wrapper.addEventListener( 'click', ( e ) => {
      let containers = this.node.querySelectorAll( '.cards__card-container' );
      let card = Helper.getClosest( e.target, '.cards__card-container' );
      let close = Helper.getClosest( e.target, '.cards__content-close' );

      if ( card !== null ) {
        for ( let container of containers ) {
          if ( card === container && !wrapper.classList.contains( 'cards-outer--detail-view' ) && window.innerWidth > 1023 && close === null ) {
            wrapper.classList.add( 'cards-outer--detail-view' );
            for ( let big of containers ) {
              let inner = big.querySelector( '.cards__image-inner' );
              if ( inner ) {
                const imageBig = inner.getAttribute( 'data-big' );
                if ( imageBig ) {
                  let image = big.querySelector( '.cards__image' );
                  image.src = imageBig;
                  image.setAttribute( 'data-src', imageBig );
                }
              }
            }
            let index = parseInt( container.getAttribute( 'data-id' ));
            if ( this.slider !== null ) {
              this.slider.destroy( true );
              this.slider = this.initSlider( 1 );
              this.addPagination();
              this.slider.goTo( index - 1 );
              this.setActivePagination( index - 1 );
              this.handleButtonPosition();
            } else {
              this.slider = this.initSlider( 1 );
              this.addPagination();
              this.slider.goTo( index - 1 );
              this.setActivePagination( index - 1 );
              this.handleButtonPosition();
            }
          } else if ( window.innerWidth > 1023 && close !== null ) {
            wrapper.classList.remove( 'cards-outer--detail-view' );
            this.removeBackground();
            this.handleWindowSize();
          }
        }
      }
    });
  }
  removeBackground() {
    let containers = this.node.querySelectorAll( '.cards__card-container' );
    for ( let container of containers ) {
      let imageTile = container.querySelector( '.cards__image-inner' ).getAttribute( 'data-tile' );
      let image = container.querySelector( '.cards__image' );
      image.src = imageTile;
    }
  }
  addEventhandler() {
    window.addEventListener( 'resize', Helper.debounce(() => {
      let wrapper = Helper.getClosest( this.node, '.cards-outer' );

      if ( window.innerWidth < this.sizeL && wrapper.classList.contains( 'cards-outer--detail-view' )) {
        wrapper.classList.remove( 'cards-outer--detail-view' );
        this.removeBackground();
      }
      if ( !wrapper.classList.contains( 'cards-outer--detail-view' )) {
        this.handleWindowSize();
      }

      this.handleButtonPosition();
      if ( wrapper.classList.contains( 'cards-outer--swipeable' ) && !this.node.children[ 0 ].classList.contains( 'cards__slider' )) {
        this.node.children[ 0 ].classList.add( 'cards__slider' );
      }
    }, 250 ));
  }
  handleWindowSize() {
    if ( window.innerWidth < this.sizeL && this.slider === null ) {
      this.addSlider( 1 );
    } else if ( window.innerWidth < this.sizeL && this.slider !== null ) {
      this.checkSlider( 1 );
    } else if ( window.innerWidth >= this.sizeL && window.innerWidth < this.sizeXL && this.slider === null ) {
      this.addSlider( 2 );
    } else if ( window.innerWidth >= this.sizeL && window.innerWidth < this.sizeXL && this.slider !== null ) {
      this.checkSlider( 2 );
    } else if ( window.innerWidth >= this.sizeXL && window.innerWidth < this.sizeXXL && this.slider !== null ) {
      this.checkSlider( 3 );
    } else if ( window.innerWidth >= this.sizeXL && window.innerWidth < this.sizeXXL && this.slider === null ) {
      this.addSlider( 3 );
    } else if ( window.innerWidth >= this.sizeXXL && this.slider === null ) {
      this.addSlider( 4 );
    } else if ( window.innerWidth >= this.sizeXXL && this.slider !== null ) {
      this.checkSlider( 4 );
    }
  }
  addSlider( amount ) {
    let wrapper = Helper.getClosest( this.node, '.cards-outer' );
    let cardsContainer = this.node.querySelectorAll( '.cards__card-container' ).length;

    if ( cardsContainer > amount ) {
      wrapper.classList.add( 'cards-outer--swipeable' );
      this.slider = this.initSlider( amount );
      this.node.children[ 0 ].classList.add( 'cards__slider' );
      this.addPagination();
      this.setActivePagination( 0 );
      this.addAnimation();
      // this.initDetailClickEvent();
      this.handleButtonPosition();
    }
  }
  checkSlider( amount ) {
    let pages = this.slider.perPage;

    if ( pages !== amount ) {
      let wrapper = Helper.getClosest( this.node, '.cards-outer' );
      let paginationBtns = wrapper.querySelectorAll( '.cards__pagination-box' );
      let current = this.slider.currentSlide;

      if ( current === -1 ) {
        current = paginationBtns.length - 1;
      } else if ( current === -2 ) {
        current = paginationBtns.length - 2;
      } else if ( current === -3 ) {
        current = paginationBtns.length - 3;
      }

      let index = parseInt( this.slider.innerElements[ current ].dataset.id );

      this.slider.destroy( true );
      this.slider = null;
      wrapper.classList.remove( 'cards-outer--swipeable' );
      let cardsContainer = this.node.querySelectorAll( '.cards__card-container' );
      if ( cardsContainer.length > amount ) {
        wrapper.classList.add( 'cards-outer--swipeable' );
        this.slider = this.initSlider( amount );
        this.node.children[ 0 ].classList.add( 'cards__slider' );
        this.addPagination();
        this.slider.goTo( index - 1 );
        this.setActivePagination( index - 1 );
        this.addAnimation();
        // this.initDetailClickEvent();
        this.handleButtonPosition();
      } else {
        for ( let i = 0; i < cardsContainer.length; i++ ) {
          cardsContainer[ i ].style.marginRight = 0;
          cardsContainer[ i ].style.marginLeft = 0;
        }
      }
    }
  }
}
